import { Component, OnInit } from '@angular/core';
import { CrudService } from '../../../crud/crud.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-dashboard-factura',
  templateUrl: './dashboard.component.html'
})

export class DashboardFacturaComponent implements OnInit{
  tamano;
  cargando = false;
  sin_resultado = '';
  dashboard = {};
  configuracion = JSON.parse(localStorage.getItem('configuracion'));
  constructor(private crudService: CrudService) { }

  ngOnInit() {
    this.tamano = document.body.clientHeight;
    this.estadistica();
  }

  estadistica() {
    this.cargando = true;

    let datos: any = `username=${this.configuracion.sucursal.facturacion.use_facturatelo}&password=${this.configuracion.sucursal.facturacion.pwd_facturatelo}&usuario=${this.configuracion.sucursal.facturacion.use_facturatelo}`;
    this.dashboard = {};

    this.crudService.crear(datos, environment.CFDI_PATH + "/api/v1/dashboard").subscribe(
      resultado => {
        this.cargando = false;
        if (resultado.status === 200) {
          this.dashboard = resultado.data;
        } else {
          this.sin_resultado = resultado.messages;
          setTimeout(() => {
            this.sin_resultado = '';
          }, 3000);
        }

      },
      error => {
        this.cargando = false;
      }
    );

  }
}
